import React from 'react'
import Hero from '../components/Hero'
import HeroImage from '../../public/GS_packages_hero.jpeg'
import { PackagesWrapper } from '../components/packages/styles'
import { useMarketContext } from '../components/MarketContext'
import { Header2, Text } from '../styles/Components'
import MarketSelector from '../components/MarketSelector'
import SelectProductButton from '../components/SelectProductButton'
import { fetchSingleProduct } from '../services'
import { gsColors } from '../styles/Variables'
import Head from 'next/head'
import FAQ from '../faq'

const FAQ_DATA_PACKAGES = [
  {
    id: 1,
    title:
      'Why do I have an additional charge when my package is applied to my service?',
    body: 'There are a few scenarios where you may pay in addition to your existing package credits that have been applied to your appointment. If you have a package of blowouts and book for an updo which costs more, additional credits will be subtracted from your package to cover the cost of the updo. This will leave your package with an uneven amount of credits. When you use the last of your credits you will have an additional charge to cover what the credits did not cover in that appointment. If you have a blowout package and book a blowout plus a manicure, only the blowout package will apply and you will be charged for the manicure.',
  },
  {
    id: 2,
    title: 'How do packages work?',
    body: "When you purchase a package you're essentially purchasing service credits at a discounted rate. For example, the cost for a package of 5 blowouts will be at a discounted rate plus the gratuity of the full service, the support fee, and tax if applicable. The credits you are given will reflect the full price of the services in your account once the transaction is complete.",
  },
  {
    id: 3,
    title: 'Why should I purchase a package?',
    body: "Glamsquad isn't just for special occasions. Packages are a great way to save money for those who want to make looking and feeling great a regular part of their routine. Glamsquad package credits never expire!",
  },
]

const FAQ_URL = '/faq/category/service-packages'

export const getServerSideProps = async () => {
  const product = await fetchSingleProduct(
    process.env.NEXT_PUBLIC_VIP2_BUNDLE_ID
  )
  return { props: { product } }
}

const FirstTimeOffer = ({ product }) => {
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()

  return (
    <>
      <Head>
        <title>VIP Bundle | Glamsquad</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <PackagesWrapper>
        <Hero
          className="hero-class"
          header="BUNDLE YOUR BEAUTY"
          subheader="Our beauty packages are the perfect way to enjoy more of the signature services you love at amazing prices."
          image={HeroImage}
        />

        <div className="content-container">
          <div className="packages-content">
            <div className="package-steps">
              <div className="step-1">
                <Header2 align="center">Select location</Header2>
                <MarketSelector
                  markets={markets}
                  selected={selectedMarket}
                  setSelected={setSelectedMarket}
                />
              </div>

              <div className="step-2" id="main-content" tabIndex="0">
                {/* <Text
                  className="subtitle"
                  margin="15px 0"
                  color={gsColors.meredithGrey}
                  variant="small"
                >
                  We&apos;ll add tax & gratuity to the price before checkout.
                  Packages do not expire and are available in all markets except
                  the Hamptons.
                </Text> */}
                <div className="packages-container">
                  <div
                    id={product.sku}
                    key={product.id}
                    className="package-card selected-package"
                  >
                    <div className="card-content">
                      <Text variant="medium" weight="600">
                        {product.name}
                      </Text>
                      <span style={{ display: 'flex' }}>
                        <Text
                          color={gsColors.cobalt}
                          weight="600"
                          margin="0 8px 0 0"
                        >
                          {product.discountLabel}
                        </Text>
                        <Text>(${product.creditAmount} value)</Text>
                      </span>
                      {product.description && (
                        <Text
                          fontSize={13}
                          color={gsColors.meredithGrey}
                          lineHeight="18px"
                        >
                          {product.description}
                        </Text>
                      )}
                    </div>
                    <Text>${product.price}</Text>
                  </div>
                </div>
                <Text
                  className="subtitle"
                  style={{ margin: '0' }}
                  color={gsColors.meredithGrey}
                  variant="small"
                >
                  We&apos;ll add tax & gratuity to the price before checkout.
                </Text>
                <div className="select-product-button">
                  <SelectProductButton
                    color={gsColors.sunsetOrange}
                    product={product}
                    fromPath="packages"
                    buttonText="Redeem Now"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="faq-wrapper">
          <FAQ data={FAQ_DATA_PACKAGES} url={FAQ_URL} />
        </div>
      </PackagesWrapper>
    </>
  )
}

export default FirstTimeOffer

